import {
  isChakraTheme,
  requiredChakraThemeKeys
} from "./chunk-P56GPN75.mjs";
import {
  foundations
} from "./chunk-3WO5B3NB.mjs";
import "./chunk-SIH73G3H.mjs";
import "./chunk-45VJLTIL.mjs";
import "./chunk-B75T2J64.mjs";
import "./chunk-TXLFBUTF.mjs";
import "./chunk-E47HH2QS.mjs";
import "./chunk-VIVTPWHP.mjs";
import "./chunk-IZUFFCXS.mjs";
import "./chunk-HQ6WXDYV.mjs";
import {
  components
} from "./chunk-P7SDT22G.mjs";
import "./chunk-Q5NOVGYN.mjs";
import "./chunk-SG67NFYS.mjs";
import "./chunk-QWN3S45W.mjs";
import "./chunk-GYISOX2E.mjs";
import "./chunk-7RVLYCMR.mjs";
import "./chunk-KJ26FGJD.mjs";
import "./chunk-R7ZISUMV.mjs";
import "./chunk-37MNRBP2.mjs";
import "./chunk-VZUATZ4E.mjs";
import "./chunk-NNA4E64A.mjs";
import "./chunk-X6XFE4TF.mjs";
import "./chunk-ZREGO6US.mjs";
import "./chunk-5FA7Y3RP.mjs";
import "./chunk-L3YAB6CV.mjs";
import "./chunk-2KWJXISX.mjs";
import "./chunk-AFCBUAM5.mjs";
import "./chunk-V5KSHSOQ.mjs";
import "./chunk-MGNM2WZQ.mjs";
import "./chunk-N2GP2AF7.mjs";
import "./chunk-JN6QBAR6.mjs";
import "./chunk-57T4IAPW.mjs";
import "./chunk-6XA2KDUD.mjs";
import "./chunk-OEFJDLVS.mjs";
import "./chunk-U3INMHUO.mjs";
import "./chunk-VWP3ZVQT.mjs";
import "./chunk-D6DZ26HA.mjs";
import "./chunk-O6GGGS4Y.mjs";
import "./chunk-SRBDDT7F.mjs";
import "./chunk-VHM7WLW6.mjs";
import "./chunk-WXARPSDQ.mjs";
import "./chunk-ICL3HPTT.mjs";
import "./chunk-FU5DDBRC.mjs";
import "./chunk-MBVM6PEK.mjs";
import "./chunk-F7CKIHPM.mjs";
import "./chunk-XHYVH6UO.mjs";
import "./chunk-OB7MMEC3.mjs";
import "./chunk-K3RH7Y2L.mjs";
import "./chunk-TECE6HDR.mjs";
import "./chunk-5S44M2O4.mjs";
import {
  semanticTokens
} from "./chunk-5GOSZLB7.mjs";
import {
  styles
} from "./chunk-3F7U33P5.mjs";
import "./chunk-6HLEZRJI.mjs";
import "./chunk-J7AGDWFO.mjs";
import "./chunk-BNQWYFTH.mjs";
import "./chunk-Q5ZQE4MD.mjs";
import "./chunk-NJCYBKFH.mjs";
import "./chunk-V7WMN6TQ.mjs";
import "./chunk-UV3F75RF.mjs";
import "./chunk-ZQMLTFF3.mjs";

// src/index.ts
var direction = "ltr";
var config = {
  useSystemColorMode: false,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
};
var theme = {
  semanticTokens,
  direction,
  ...foundations,
  components,
  styles,
  config
};
var baseTheme = {
  semanticTokens,
  direction,
  components: {},
  ...foundations,
  styles,
  config
};
export {
  baseTheme,
  isChakraTheme,
  requiredChakraThemeKeys,
  theme
};
//# sourceMappingURL=index.mjs.map